// React for Website

import React, { useState } from "react";
//outsource
import { Form, Checkbox, Row } from "antd";

//components

const StaffRoster = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row span={24}>
      <Form.Item name="shopRoster" valuePropName="checked">
        <Checkbox disabled={disabled}>Shop Roster</Checkbox>
      </Form.Item>
      <Form.Item name="individualRoster" valuePropName="checked">
        <Checkbox disabled={disabled} style={{ paddingLeft: 40 }}>
          Individual Roster
        </Checkbox>
      </Form.Item>
    </Row>
  );
};

export default StaffRoster;
